<template>
  <div />
</template>
<script>
  export default {
    name: 'Toaster',
    props: {
      alertType: {
        type: String,
        default: 'info',
      },
      alertText: {
        type: String,
        default: '',
      },
    },
    mounted () {
      this.$toast[this.alertType](this.alertText)
    },
  }
</script>
<style>
.Vue-Toastification__toast--success {
  background-color: #33A08E !important
}
.Vue-Toastification__toast--error{
  background-color: #D16565 !important
}
.Vue-Toastification__toast--warning{
  background-color: #E19147 !important
}

</style>
